import { render, staticRenderFns } from "./footer-btns.vue?vue&type=template&id=c65421a8&scoped=true"
import script from "./footer-btns.vue?vue&type=script&lang=ts"
export * from "./footer-btns.vue?vue&type=script&lang=ts"
import style0 from "./footer-btns.vue?vue&type=style&index=0&id=c65421a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c65421a8",
  null
  
)

export default component.exports